import { forwardRef, useState } from "react";
import {
  AppBar,
  Box,
  Collapse,
  Dialog,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Grid from "@mui/material/Unstable_Grid2";

import DayOfWeek from "./filters/DayOfWeek";
import TimeOfDay from "./filters/TimeOfDay";
import Radius from "./filters/Radius";
import SpecialTests from "./filters/SpecialTests";
import WCDButton from "../ui/WCDButton";
import { useSearchParams } from "react-router-dom";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Filters = ({ open, onClose }) => {
  const isSmallDevice = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handleCloseFilterDialog = () => {
    onClose();
  };

  const [selectedDays, setSelectedDays] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [radius, setRadius] = useState();
  const [selectedTests, setSelectedTests] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const handleApplyFilterButton = () => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      ...(selectedDays.length !== 0 && { days: JSON.stringify(selectedDays) }),
      ...(startTime &&
        endTime && { time: JSON.stringify(startTime + "to" + endTime) }),
      ...(radius && { radius: JSON.stringify(radius) }),
      ...(selectedTests.length !== 0 && {
        tests: JSON.stringify(selectedTests),
      }),
    });

    onClose();
  };

  if (isSmallDevice) {
    return (
      <Dialog
        fullScreen
        open={open}
        onClose={handleCloseFilterDialog}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative", backgroundColor: "#0B3C65" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseFilterDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Filter
            </Typography>
            <Box>
              <WCDButton
                text="Apply"
                onClick={handleApplyFilterButton}
                startIcon={<FilterAltIcon />}
              />
            </Box>
          </Toolbar>
        </AppBar>
        <Box sx={{ padding: "15px 20px" }}>
          <Stack spacing={2}>
            <DayOfWeek
              type="Accordion"
              onDaysChange={(value) => {
                setSelectedDays(value);
              }}
            />
            <TimeOfDay
              type="Accordion"
              onTimeChange={(start, end) => {
                if (start && end) {
                  setStartTime(start.format("HH:mm"));
                  setEndTime(end.format("HH:mm"));
                }
              }}
            />
            <Radius
              type="Accordion"
              onRadiusChange={(value) => {
                setRadius(value);
              }}
            />
            <SpecialTests
              type="Accordion"
              onSpecialTestsChange={(value) => {
                setSelectedTests(value);
              }}
            />
          </Stack>
        </Box>
      </Dialog>
    );
  } else {
    return (
      <Collapse in={open}>
        <Grid
          container
          spacing={2}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid xs={6} sm={3}>
            <DayOfWeek />
          </Grid>
          <Grid xs={6} sm={3}>
            <TimeOfDay />
          </Grid>
          <Grid xs={6} sm={3}>
            <Radius />
          </Grid>
          <Grid xs={6} sm={3}>
            <SpecialTests />
          </Grid>
        </Grid>
      </Collapse>
    );
  }
};

export default Filters;
